import React from "react";
import Overview from "./Overview";
import Add from "./Add";
import Edit from "./Edit";

import { LanguageProvider } from "../../context/LanguageContext";

export const Language = () => {
  return (
    <LanguageProvider>
      <Overview />
    </LanguageProvider>
  );
};

export const AddLanguage = () => {
  return (
    <LanguageProvider>
      <Add />
    </LanguageProvider>
  );
};

export const EditLanguage = () => {
  return (
    <LanguageProvider>
      <Edit />
    </LanguageProvider>
  );
};
